import { ReactElement, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import debounceFunc from 'lodash/debounce';

interface IProps {
  debounce?: number;
  initialValues: any;
  onSubmit: (values: any) => void;
  setLoading?: (loading: boolean) => void;
}

const AutoSubmit = ({
  debounce = 0,
  initialValues,
  onSubmit,
  setLoading,
}: IProps): ReactElement => {
  const {
    handleSubmit,
    watch,
    formState: { isSubmitting },
  } = useFormContext();

  const handleSubmitForm = debounceFunc(() => handleSubmit(onSubmit)(), debounce);

  useEffect(() => {
    const subscription = watch(values => {
      if (values === initialValues || isSubmitting) return;
      setLoading?.(true);
      handleSubmitForm();
    });

    return () => subscription.unsubscribe();
  }, [handleSubmitForm, initialValues, isSubmitting, watch, setLoading]);

  return null;
};

export default AutoSubmit;
